module.exports = __webpack_public_path__ + "static/mobile-app-img-5-a684de0aa857b0a7fb0bb9db816529a5.png";